'use client'

import { setGADataLayer } from 'analytics'
import type {
    FreestarOpportunity,
    FreestarSlotConfig,
    FreestarSuppressionReason,
    FreestarTelemetryState,
} from './types'

type FreestarTelemetryEvent = {
    event: 'freestar_client_content'
    options: {
        ad: {
            provider: 'freestar'
            state: FreestarTelemetryState
            view: string
            device_type: string
            backend_cleared: boolean
            reason?: FreestarSuppressionReason
            slot_id?: string
            slot_kind?: string
        }
    }
}

export function buildFreestarTelemetryEvent({
    opportunity,
    state,
    reason,
    slot,
}: {
    opportunity: FreestarOpportunity
    state: FreestarTelemetryState
    reason?: FreestarSuppressionReason
    slot?: FreestarSlotConfig
}): FreestarTelemetryEvent {
    return {
        event: 'freestar_client_content',
        options: {
            ad: {
                provider: 'freestar',
                state,
                view: opportunity.context.view,
                device_type: opportunity.context.deviceType,
                backend_cleared: opportunity.backendCleared,
                ...(reason ? { reason } : {}),
                ...(slot ? { slot_id: slot.slotId, slot_kind: slot.kind } : {}),
            },
        },
    }
}

export function trackFreestarEvent(options: Parameters<typeof buildFreestarTelemetryEvent>[0]) {
    setGADataLayer(buildFreestarTelemetryEvent(options))
}
